import Servico from './Servico'

class TabelaServico extends Servico {
  constructor() {
    super('tabela')
  }
}

export default TabelaServico
